import axiosInstance from "../config/axiosIntance";
import { getDraftByIdResponse } from "../types";

type Params = {
  draftId: string;
  token: string;
};

export const getDraftsByIdService = async ({ token, draftId }: Params): Promise<getDraftByIdResponse> => {
  const dataFetched = await axiosInstance.get(`/consent-config/draft/${draftId}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  return dataFetched.data;
};
